"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8835],{

/***/ 5315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


function GoMoreLink(param) {
    var url = param.url, text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: url,
        passHref: true,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex gap-4 items-center relative contact-border group duration-300 -ml-14 lg:ml-0 cursor-pointer ".concat(url === "/careers" && "contact-b"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-[.92857rem] group-hover:pl-1 duration-300 font-bold text-redblack leading-[1.42857em] capitalize",
                children: text
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (GoMoreLink);


/***/ }),

/***/ 18835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ WhatWeDoSection_WhatWeDoSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/GoMore/GoMoreLink.tsx
var GoMoreLink = __webpack_require__(5315);
// EXTERNAL MODULE: ./src/state/index.tsx
var state = __webpack_require__(9417);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 1 modules
var gsap = __webpack_require__(10990);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constant/index.tsx + 38 modules
var constant = __webpack_require__(17089);
;// CONCATENATED MODULE: ./src/views/Home/WhatWeDoSection/WhatWeDoSection.tsx








var MobileSlider = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 469).then(__webpack_require__.bind(__webpack_require__, 70469));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70469)
            ];
        }
    }
});
var WWDCard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6787).then(__webpack_require__.bind(__webpack_require__, 26787));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26787)
            ];
        }
    }
});
// Use React.memo to memoize the component
var MemoizedComponent = /*#__PURE__*/ react.memo(WWDCard);
function WhatWeDoSection() {
    var sectionScrollHeight = (0,react.useRef)(null);
    var ref = (0,_sliced_to_array/* default */.Z)((0,state/* useWhatWeDoScrollHeight */.LD)(), 2), scrollHeight = ref[0], setScrollHeight = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        setScrollHeight((ref = sectionScrollHeight.current) === null || ref === void 0 ? void 0 : ref.clientHeight);
    }, [
        scrollHeight
    ]);
    // Gsap Animations
    (0,react.useEffect)(function() {
        var WhatWeDoTimeline = gsap/* default.timeline */.ZP.timeline({
            scrollTrigger: {
                trigger: "._whatWeDoSectionTrigger",
                start: "top 65%"
            }
        });
        WhatWeDoTimeline.to("._whatWeDoNameText, ._whatWeDoTitleDesc, ._whatWeDoGoMoreBtn", {
            opacity: 1,
            y: 0,
            x: 0,
            duration: 1.1
        }).to("._whatWeDoCategories", {
            y: 0,
            opacity: 1,
            duration: 1.1,
            stagger: 0.1
        }, "-=.8");
    }, []);
    return(// lg:my-[14rem] mb-[4rem] mt-[9rem] flex items-center lg:pr-[70px] lg:pl-[90px] 2xl:pl-[140px]
    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: sectionScrollHeight,
        id: "TopToDown",
        className: "mt-[5.5rem] mb-[5rem] lg:mb-[15.7rem] lg:mt-[10rem] 2xl:mt-[14rem] lg:mx-[5rem] xl:px-[3.85714rem] lg:pl-[3.85714rem] lg:pr-0 px-[2.5rem] _whatWeDoSectionTrigger",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lg:grid desktop:gap-[30px] xl:gap-[150px] gap-[50px] lg:grid-cols-[4fr,8fr] 2xl:grid-cols-[3fr,9fr] xl:grid-cols-[3fr,8fr] lg:items-start ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-[60px] lg:space-y-[40px] md:w-[90%] desktop:w-[65%]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-y-6 lg:space-y-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-5 items-center translate-x-8 opacity-0 _whatWeDoNameText",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "inline-block w-5 h-0.5 bg-redblack"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "uppercase font-primary font-semibold text-[13px] tracking-[.13286rem] leading-[20px] text-redblack",
                                            children: "SERVICES"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-8 _whatWeDoTitleDesc opacity-0 translate-y-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-[26px] leading-[32px] font-bold w-full ",
                                            children: "Innovation and impact."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "leading-[27px] text-[22px] text-[#4A4A4A] font-primary ",
                                            children: [
                                                "Here, there is only",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    className: "text-primary",
                                                    children: "ONE GOAL"
                                                }),
                                                ": Create and optimize every user experience in a way that generates real results."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg:hidden ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSlider, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "-translate-x-8 opacity-0 _whatWeDoGoMoreBtn flex justify-center lg:justify-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoMoreLink/* default */.Z, {
                                text: "Discover More",
                                url: "/services"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:grid lg:grid-cols-2 xl:grid-cols-2 desktop:grid-cols-4 gap-[70px] xl:pl-0 lg:pl-[5rem] hidden",
                    children: constant/* whatWeDoCategory.map */.Bv.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedComponent, {
                            data: item
                        }, "".concat(i, "wwwd"));
                    })
                })
            ]
        })
    }));
}
/* harmony default export */ var WhatWeDoSection_WhatWeDoSection = (WhatWeDoSection);

;// CONCATENATED MODULE: ./src/views/Home/WhatWeDoSection/index.ts




/***/ })

}]);